module.exports = __webpack_public_path__ + "media/metronic/_theme/media/users/300_4-52cf2ea6505b98cc754bb079c8a09111.jpg";